const Localisations = {
  COSTARICA: 'COSTA RICA',
  EQUATEUR: 'ÉQUATEUR',
  PANAMA: 'PANAMA',
  PEROU: 'PÉROU',
}

export default Localisations
